<template>
	<div v-if="hasAlerts">
		<div v-if="warning.kind === 'stale'" class="paas-coords-stale-alert paas-list-status-warn-below">
			<WarningOutlined class="paas-coords-stale-icon" />
			<span>{{ $t('paas.listPanel.coordsStaleDays', warning.days) }}</span>
		</div>
		<div v-else-if="warning.kind === 'never'" class="paas-coords-stale-alert paas-list-status-warn-below">
			<WarningOutlined class="paas-coords-stale-icon" />
			<span>{{ $t('paas.listPanel.never') }}</span>
		</div>
		<div v-if="problemsCount > 0" class="paas-coords-stale-alert paas-list-status-warn-below paas-list-status-problems">
			<WarningOutlined class="paas-coords-stale-icon" />
			<span>{{ $t('paas.listPanel.problemsWithStations', problemsCount) }}</span>
		</div>
	</div>
</template>

<script>
import { computed } from 'vue';
import { WarningOutlined } from '@ant-design/icons-vue';

import Consts from '@/api/Consts';


export default {
	components: {
		WarningOutlined,
	},
	props: {
		warning: {
			type: Object,
			required: true,
		},
		problemsCount: {
			type: Number,
			required: true,
		},
	},
	setup(props) {
		const hasAlerts = computed(() => (
			props.warning.kind === 'stale'
			|| props.warning.kind === 'never'
			|| props.problemsCount > 0
		));
		return {
			hasAlerts,
			colorWarningDark: Consts.COLORS.warningDark,
		};
	},
};
</script>

<style scoped>
.paas-list-status-problems {
	white-space: normal;
}

.paas-list-status-warn-below {
	margin-top: 8px;
}

.paas-coords-stale-alert {
	line-height: 1.4;
	color: v-bind(colorWarningDark);
}

.paas-coords-stale-icon {
	color: v-bind(colorWarningDark);
	margin-right: 4px;
}
</style>
